export const appRootUrl = "https://app.swiss-bitcoin-pay.ch";
